import script from "./PassengerDetailsPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./PassengerDetailsPopup.vue?vue&type=script&setup=true&lang=js"

import "./PassengerDetailsPopup.vue?vue&type=style&index=0&id=0d97f6e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d97f6e9"]])

export default __exports__